import React, {useState, useEffect} from 'react'
import { Container, Row, Col } from 'reactstrap'
import axios from 'axios'
import AsyncSelect from 'react-select/async';
import DatePicker from 'react-datepicker';

import { toast } from 'react-toastify';

export default function QAReportGeneration() {
    const [loading, setLoading] = useState(false)
    const [loadingBtns, setLoadingBtns] = useState(false)
    const [errors, setErrors] = useState({})
    const [dropdownOptions, setDropdownOptions] = useState({})
    const [selectedSite, setSelectedSite] = useState({})
    const [startDate, setStartDate] = useState(new Date())
    const [endDate, setEndDate] = useState(new Date())
    const [qaPendingStatus, setQaPendingStatus] = useState(false)
    
   

    useEffect(() => {
        fetchSiteNames();
    }, [])


    
    
    function fetchSiteNames() {
        axios.get('/api/v1/internal/dropdown_list_helper')
        .then(res => {
            let site_names = res.data.site_names, site_names_options = []
            for (var key in site_names) {
            let group = {}, children = []
            group['label'] = <div className="fw-bold col text-black">{key}</div>
            site_names[key].map(item => {
                children.push({ label: item, value: item })
            })
            group['options'] = children;
            site_names_options.push(group)
            }
            site_names_options.push({ label: <div className="fw-bold text-black">All</div>, options: [{ label: 'All', value: 'all' }] })
            setDropdownOptions(site_names_options)
        })
        .catch(err => {
            console.error(err?.message || 'Oops something went wrong')
        })
    }
      
    const promiseOptions = (inputValue) => {
        if(inputValue.length < 3){
            return null
        } else {
            return new Promise((resolve) => {
            axios.get(`/api/v1/internal/search_site_names?site_name=${inputValue}`).then(res => {
                if (res.status == '200'){
                let site_names = res.data.site_names, site_names_options = []
                for (var key in site_names) {
                    let group = {}, children = []
                    group['label'] = <div className="fw-bold col text-black">{key}</div>
                    site_names[key].map(item => {
                    children.push({ label: item, value: item })
                    })
                    group['options'] = children;
                    site_names_options.push(group)
                }
                site_names_options.push({ label: <div className="fw-bold text-black">All</div>, options: [{ label: 'All', value: 'all' }] })
                setDropdownOptions(site_names_options)
                resolve(site_names_options)
                }
            }).catch(err => {
                    console.log(`err`, err)
                })
            })
        }
    }

    const handleSubmit = () => {
        setLoadingBtns(true)
        setErrors({})
        let tempObj = {}
        if (!(selectedSite?.value) || !(startDate) || !(endDate)){
            tempObj = {...tempObj, site:true}
        }
        setErrors(tempObj)

        if (Object.keys(tempObj)?.length == 0){
            let resultObj = {
                "outer_command": "qa_report_generation",
                "inner_command": "qa_report_generation",
                "nested_inner_command": "qa_report_generation",
                "sitename": selectedSite?.value,
                "from_date": startDate,
                "to_date": endDate,
                "qa_pending": qaPendingStatus
            }
            axios.post('/api/v1/internal/command_dashboard/qa_report_generation', {
                filter: resultObj
            }).then(res => {
                toast.success(res?.data?.message)
                setLoadingBtns(false)
                window.location = `/internal/command_dashboard`
            }).catch(err => {
                toast.error(err?.response?.data?.message)
                setLoadingBtns(false)
            })
        }
        else {
            setLoadingBtns(false)
        }
    }

    function onQaPendingStatusCheckedHandler() {
        setQaPendingStatus(!qaPendingStatus)
    }

    return (
        <Container fluid>
            <Row>
                <Col md={4} className='my-3'>
                    <h6 className='fw-bold'>Outer Command (Non-Editable)</h6>
                    <input className='form-control' value='qa_report_generation'
                        disabled />
                </Col>
                <Col md={4} className='my-3'>
                    <h6 className='fw-bold'>Inner Command (Non-Editable)</h6>
                    <input className='form-control' value='qa_report_generation'
                        disabled />
                </Col>
                <Col md={4} className='my-3'>
                    <h6 className='fw-bold'>Nested Inner Command (Non-Editable)</h6>
                    <input className='form-control' value='qa_report_generation'
                        disabled />
                </Col>
                <Col md={4} className='my-3'>
                    <h6 className='fw-bold'>Site Name*</h6>
                    <AsyncSelect cacheOptions defaultOptions={dropdownOptions} name='site_name' 
                        value={selectedSite} loadOptions={promiseOptions} onChange={res => setSelectedSite(res)}
                        placeholder="Select a site name" />
                    {errors?.site && <h6 className='fw-bold text-danger my-2'> This field is required </h6>}
                    <p><i>Please type atleast 3 characters while searching the sitename!</i></p>
                </Col>
                <Col md={4} className='my-3'>
                    <h6 className='fw-bold'>From Date</h6>
                    <DatePicker 
                    className="form-control" 
                    dateFormat="yyyy/MM/dd"
                    selected={startDate} 
                    onChange={(date) => setStartDate(date)} />
                </Col>
                <Col md={4} className='my-3'>
                <h6 className='fw-bold'>To Date</h6>
                    <DatePicker 
                    className="form-control" 
                    dateFormat="yyyy/MM/dd"
                    selected={endDate} 
                    onChange={(date) => setEndDate(date)} />
                </Col>
                <Col md="4"></Col>
                <Col md="4">
                    <div className='d-flex flex-row justify-content-center align-items-center'>
                        <label className='h6 fw-bold'>
                            <input
                            type="checkbox"
                            checked={qaPendingStatus}
                            onChange={onQaPendingStatusCheckedHandler}
                            className='mx-2'
                            />
                            QA Pending
                        </label>
                    </div>
                </Col>
                <Col md="4"></Col>
                <Col md="3"></Col>
                <Col md={6} className='my-3'>
                    <button className='btn btn-success' onClick={handleSubmit}
                        disabled={loadingBtns} style={{margin: '25px auto', width: '100%'}}> Submit </button>
                </Col>
                <Col md="3"></Col>
            </Row>
        </Container>
    )
}
